export default __webpack_public_path__ + "static/media/vest.9dca5a3a.jpg";